<template>
    <div class="section-filter">
        <div class="container">
            <div class="filters">
                <div class="clearfix">
                    <ul class="link-filter">
                        <li>
                            <ul>
                                <li v-for="s in sortings">
                                    <span v-if="s.id == ssorting">{{ s.name }}</span>
                                    <a v-if="s.id != ssorting" href="#" v-on:click.prevent="setSorting(s.id)">{{ s.name }}</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <button type="button" class="btn btn-link toggle-dds" v-on:click="showFilter = !showFilter">{{ texts.filter }} <span class="icon-down-open-mini"></span></button>
                </div>
                <div class="filter-values">
                    <div class="dds" v-if="showFilter">
                        <div v-if="brands != null && useBrandFilter">
                            <p class="h3">{{ texts.manufacturer }}</p>
                            <div v-for="b in brands" :key="b.id" class="checkbox checkable-small">
                                <label><input type="checkbox" v-model="sbrand" name="sf-brand" v-on:change.prevent="refreshFilter" :value="b" /><span v-bind:class="{ 'font-bold': (b.name == 'Adast' || b.name == 'Roland' || b.name == 'Heidelberg' || b.name == 'KBA' || b.name == 'Polly') }">{{ b.name }}</span></label>
                            </div>
                        </div>
                        <div>
                            <p class="h3">{{ texts.yearOfProduction }}</p>
                            <div v-for="y in years" :key="y.id" class="checkbox checkable-small">
                                <label><input type="checkbox" v-model="syear" name="sf-year" v-on:change.prevent="refreshFilter" :value="y.id" /><span>{{ y.name }}</span></label>
                            </div>
                        </div>
                        <div v-if="useFormatFilter">
                            <p class="h3">{{ texts.format }}</p>
                            <div v-for="f in formats" :key="f.id" class="checkbox checkable-small">
                                <label><input type="checkbox" v-model="sformat" name="sf-format" v-on:change.prevent="refreshFilter" :value="f.id" /><span>{{ f.name }}</span></label>
                            </div>
                        </div>
                    </div>
                    <div class="dds-selected" v-if="!showFilter && useBrandFilter">
                        <span v-for="(b, index) in sbrand" class="remove-item" v-on:click="unselectBrand(index)">
                            {{ b.name }} <span class="icon-cancel-strong"></span>
                        </span>
                        <span v-for="(y, index) in syear" class="remove-item" v-on:click="unselectYear(index)">
                            {{ getYearName(y) }} <span class="icon-cancel-strong"></span>
                        </span>
                        <span v-for="(f, index) in sformat" class="remove-item" v-on:click="unselectFormat(index)">
                            {{ getFormatName(f) }} <span class="icon-cancel-strong"></span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        name: 'search-filter',
        props: {
            brand: {
                type: Array
            },
            year: {
                type: Array
            },
            sorting: {},
            format: {
                type: Array
            },
            brands: {
                type: Array,
                required: true
            },
            years: {
                type: Array,
                required: true
            },
            texts: {
                type: Object,
                required: true
            },
            sortings: {
                type: Array,
                required: true
            },
            formats: {
                type: Array,
                required: true
            },
            useFormatFilter: {
                type: Boolean,
                required: true
            },
            useBrandFilter: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                sbrand: [],
                syear: [],
                sformat: [],
                ssorting: 0,
                showFilter: false
            }
        },
        created() {
            var self = this;
            self.sbrand = self.brand;
            self.syear = self.year;
            self.ssorting = self.sorting;
            self.sformat = self.format;

            Vue.nextTick(x => {
                $('.selectpicker').selectpicker({
                    size: 10
                })
            })
        },
        methods: {
            refreshFilter() {
                var self = this;
                self.$emit('new-filter');
            },
            setSorting(s) {
                var self = this;
                self.ssorting = s;
                self.$emit('new-filter');
            },
            unselectBrand(index) {
                this.sbrand.splice(index, 1);
                this.$emit('new-filter');
            },
            unselectYear(index) {
                this.syear.splice(index, 1);
                this.$emit('new-filter');
            },
            unselectFormat(index) {
                this.sformat.splice(index, 1);
                this.$emit('new-filter');
            },
            getYearName(y) {
                let t = this.years.find(s => s.id == y);
                if (t) {
                    return t.name;
                }
                return null;
            },
            getFormatName(f) {
                let t = this.formats.find(s => s.id == f);
                if (t) {
                    return t.name;
                }
                return null;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// _search-filter.vue?4767bf34